export default "__VITE_ASSET__b8baa92e__"